module.exports = __webpack_public_path__ + "static/media/vegan-double-chocolate-chunk.d45ad87d.png";